<script lang="ts">
	import { Icon, formatDate, getCookie, setCookie, systemInformationStore } from '@enzianweb/shared';
	import { onDestroy } from 'svelte';
	import { _ } from 'svelte-i18n';

	const MAINTENANCE_BANNER_KEY = 'Maintenance_Banner_Date';

	let hideInfoBanner: boolean = true;

	let unsub = systemInformationStore.subscribe((value) => {
		if (!value) {
			return;
		}

		let date = getCookie(MAINTENANCE_BANNER_KEY);

		//Check if we have a different one
		let targetDate = value.maintenanceDate;

		//If none is set ignore
		if (!targetDate) return;

		//Check if the value is still the same
		if (date != targetDate) {
			hideInfoBanner = false;
			//Invalidate the cookie
			setCookie(MAINTENANCE_BANNER_KEY, '', new Date());
		} else {
			hideInfoBanner = true;
		}
	});

	function hideBanner(date?: string) {
		if (!date) return;
		//Set the new cookie
		setCookie(MAINTENANCE_BANNER_KEY, date, new Date(date));
		//Hide the banner
		hideInfoBanner = true;
	}

	onDestroy(() => {
		unsub();
	});
</script>

{#if $systemInformationStore?.maintenanceDate && !hideInfoBanner}
	<div
		class="bg-background dark:bg-dark-300 flex justify-center items-center col-span-3 fill-secondary-200 dark:fill-yellow gap-2 py-2"
	>
		<Icon name="info"></Icon>
		<p class="dark:text-white">
			{$_('maintenance.lbl_info').replace(
				'{1}',
				formatDate($systemInformationStore.maintenanceDate)
			)}
		</p>
		<button
			class="ml-4"
			onclick={() => {
				hideBanner($systemInformationStore.maintenanceDate);
			}}><p class="font-bold">X</p></button
		>
	</div>
{/if}
